const format = {
  formatDateDDMMYYYY(datetime) {
    var date = new Date(datetime) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var year = date.getFullYear(),
      month = ('0' + (date.getMonth() + 1)).slice(-2),
      sdate = ('0' + date.getDate()).slice(-2)
    // 返回
    return sdate + '-' + month + '-' + year
  },
  formatDateMMYY(datetime) {
    var date = new Date(datetime) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var year = date.getFullYear().toString().substring(2, 4),
      month = ('0' + (date.getMonth() + 1)).slice(-2)
    // 返回
    return month + '/' + year
  },
  formatDateHHmmDDMMYYYY(datetime) {
    var date = new Date(datetime) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var year = date.getFullYear(),
      month = ('0' + (date.getMonth() + 1)).slice(-2),
      sdate = ('0' + date.getDate()).slice(-2),
      hour = ('0' + date.getHours()).slice(-2),
      minite = ('0' + date.getMinutes()).slice(-2)
    // 返回
    return hour + ':' + minite + ' ' + sdate + '-' + month + '-' + year
  },
  formatCharacter(character) {
    if (!character) {
      return ''
    }
    return character.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}

export default format

export function getQuery(name) {
  const w = location.hash.indexOf('?')
  const query = location.hash.substring(w + 1)

  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pari = vars[i].split('=')
    if (pari[0] == name) {
      return pari[1]
    }
  }
  return false
}
export function thousands(number) {
  const num = Number(number)
  if (num) {
    return num.toLocaleString()
  } else {
    return number
  }
}
// 0 已完成 1逾期完成， 2 申请中， 3 还款中， 4 逾期中， 5 拒绝
export function getOrderStatus(status) {
  let s = 0
  switch (status) {
    case 10: // 正常完成
    case 23: // 取消
    case 14: // 放弃取款
    case 15: // 放弃到期
      s = 0
      break
    case 11: // 异常完成
      s = 1
      break
    case 2: // 申请中
    case 16: // 初审中
    case 17: // 复审中
    case 22: // 回退再申请
      s = 2
      break
    case 6: // 放款成功
    case 19: // 还款中
    case 20: // 预催收中
      s = 3
      break
    case 21: // 逾期中，催收中
      s = 4
      break
    case 4: // 回退中
    case 5: // 已拒绝
      s = 5
      break
    case 3: // 已通过（未放款）
      s = 6
      break
    case 18: // 支付失败
      s = 7
      break
    case 7: // 拒绝到期
      s = 8
      break
    default:
      s = 0
      break
  }
  return s
}
